import React from "react";
import { useWatchState } from "@/store";
import { Modal } from "antd";
import qrImage from "./images/qr.jpg";
import "./style.less";

const NAME = "weChatQr";

const App = () => {
  const [
    [
      {
        title = "扫码关注微信公众号",
        show,
        hide,
        width = 380,
        height = "600px",
      },
    ],
  ] = useWatchState(["modal." + NAME]);

  return (
    <Modal
      title={title}
      //   className="modal-iframe"
      visible={show}
      width={width}
      maskClosable={false}
      destroyOnClose
      onCancel={hide}
      footer={false}
    >
      <div className="flex justify-center">
        <img src={qrImage} alt="" />
      </div>
      <p className="font-size-15 m-sm-t bold">
        只需四步，即可享受天合长期推送服务！步骤如下：
      </p>
      <div className="p-sm-l m-md-t">
        <p className="font-size-14">
          1. 扫码并关注 <span className="bold">“天合好需求”</span> 微信公众号
        </p>
        <p className="font-size-14 m-sm-t">2. 点击公众号下方绑定按钮</p>
        <p className="font-size-14 m-sm-t">3. 输入 手机号/验证码 并点击提交</p>
        <p className="font-size-14 m-sm-t">
          4. 在 <span className="bold">电脑端</span> 选择您感兴趣的领域
        </p>
      </div>
    </Modal>
  );
};

export default App;
